import axios from 'axios';
import { IPhysician } from 'entities/Physician/Physician.models';

const basePath = '/physicians';

export const physicianService = {
  getPhysicianList: (): Promise<IPhysician[]> => axios.get(`${basePath}`),
};
